
import { shoppingBase } from './ipConfig';

//  商品分类
export const productSubTypeUrl = `${shoppingBase}/trip-api/api/product/getProductSubTypeByRegCode`;

//  商品列表
export const productListUrl = `${shoppingBase}/trip-api/api/product/list`;

//  商品详情
export const productDetailUrl = `${shoppingBase}/trip-api/api/product/detail`;

//  商品评论
export const productCommentListUrl = `${shoppingBase}/trip-api/api/comment/getCommentList`;

//  保存用户收货地址列表
export const saveUserAddrUrl = `${shoppingBase}/trip-api/api/userDeliveryAddress/saveUserAddr`;

//  获取用户收货地址列表
export const getUserAddrListUrl = `${shoppingBase}/trip-api/api/userDeliveryAddress/getUserAddrList`;

//  删除收货人地址
export const delAddrUrl = `${shoppingBase}/trip-api/api/userDeliveryAddress/delAddr`;

//  创建订单
export const createOrderUrl = `${shoppingBase}/trip-api/api/order/createOrderMultiProduct.json`;

//  微信WAP支付
// export const wxWapUrl = `${shoppingBase}/trip-mall/zshlPayApp/wxWap.json`;
export const wxWapUrl = `${shoppingBase}/trip-mall/zshlPayApp/wxJsapi`;//   JS 支付

//  保存购物车数据接口
export const saveShoppingCartUrl = `${shoppingBase}/trip-api/api/shoppingCart/saveShoppingCart`;

//  获取购物车数据接口
export const getShoppingCartUrl = `${shoppingBase}/trip-api/api/shoppingCart/getShoppingCart`;

//获取用户订单
export const getUserOrderList = `${shoppingBase}/trip-api/api/order/getUserOrderList.json`

//获取订单详情
export const getOrderDetail = `${shoppingBase}/trip-api/api/order/getOrderDetail.json`

//删除订单
export const deleteOrder = `${shoppingBase}/trip-api/api/order/userHiddenOrder`

//取消订单
export const cancelOrder = `${shoppingBase}/trip-api/api/order/userCancelOrder`

//申请退款
export const refundOrder = `${shoppingBase}/trip-seller/sellerRefund/refund`

//图片上传 base 64
export const uploadFile = `${shoppingBase}/trip-api/api/upload/uploadFile.json`

// export const uploadFile = `http://172.16.10.47:81/trip-api/api/upload/uploadFile.json`

//评论商品
export const commentOrder = `${shoppingBase}/trip-api/api/comment/comment`

//确认收货
export const recieveConfirm = `${shoppingBase}/trip-api/api/order/recieveConfirm`

//物流信息查询接口
export const expressInfoUrl = `${shoppingBase}/trip-api/api/order/expressInfo.json`

//根据订单ID获取平台订单快递
export const getExpressByOrderIdUrl = `${shoppingBase}/trip-api/api/express/getExpressByOrderId.json`


// 文创商品
export const getCulProductUrl = `http://szzy.hnswb.net/api.php?a=shop_order`